<script lang="ts">
  const { size = '1em', width = size, height = size, fill = 'currentColor' }: { size?: string | number; width?: string | number; height?: string | number; fill?: string } = $props();
</script>

<svg {width} {height} viewBox="0 0 48 48" {fill} xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id='a' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='1' y2='1'>
       <stop offset='0' stop-color='red'>
          <animate attributeName="stop-color"
             values="#F60;#FF6;#F60" dur="10s" repeatCount="indefinite">
          </animate>
       </stop>
       <stop offset='.5' stop-color='purple'>
          <animate attributeName="stop-color"
             values="#FF6;#F60;#FF6" dur="10s" repeatCount="indefinite">
          </animate>
       </stop>
       <stop offset='1' stop-color='blue'>
          <animate attributeName="stop-color"
             values="#F60;#FF6;#F60" dur="10s" repeatCount="indefinite">
          </animate>
       </stop>
       <animateTransform attributeName="gradientTransform" type="rotate" from="0 .5 .5" to="360 .5 .5"
          dur="20s" repeatCount="indefinite" />
    </linearGradient>
  </defs>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M27.5355 3.4939C25.5829 1.54128 22.4171 1.54128 20.4645 3.4939L16.9584 7H12C9.23857 7 7 9.23858 7 12V16.9584L3.4939 20.4645C1.54128 22.4171 1.54128 25.5829 3.4939 27.5355L7 31.0416V36C7 38.7614 9.23857 41 12 41H16.9584L20.4645 44.5061C22.4171 46.4587 25.5829 46.4587 27.5355 44.5061L31.0416 41H36C38.7614 41 41 38.7614 41 36V31.0416L44.5061 27.5355C46.4587 25.5829 46.4587 22.4171 44.5061 20.4645L41 16.9584V12C41 9.23858 38.7614 7 36 7H31.0416L27.5355 3.4939ZM24 37C31.1797 37 37 31.1797 37 24C37 16.8203 31.1797 11 24 11C16.8203 11 11 16.8203 11 24C11 31.1797 16.8203 37 24 37ZM24 39C32.2843 39 39 32.2843 39 24C39 15.7157 32.2843 9 24 9C15.7157 9 9 15.7157 9 24C9 32.2843 15.7157 39 24 39ZM19.6037 31.8706L23.4991 29.7305C23.8126 29.5582 24.1872 29.5582 24.5008 29.7305L28.3961 31.8706C28.6056 31.9857 28.8456 32.0254 29.0789 31.9836C29.6648 31.8786 30.0583 31.2971 29.9578 30.6848L29.2139 26.1521C29.154 25.7872 29.2698 25.4149 29.5234 25.1565L32.6748 21.9464C32.8443 21.7738 32.9546 21.5475 32.9887 21.3027C33.0742 20.688 32.6666 20.1172 32.0783 20.0279L27.7232 19.3666C27.3726 19.3133 27.0696 19.0832 26.9128 18.7513L24.9651 14.6272C24.8604 14.4054 24.6885 14.2259 24.4763 14.1164C23.9432 13.8415 23.2978 14.0702 23.0347 14.6272L21.0871 18.7513C20.9303 19.0832 20.6272 19.3133 20.2767 19.3666L15.9216 20.0279C15.6873 20.0635 15.4708 20.1787 15.3056 20.3559C14.8907 20.8007 14.8994 21.5128 15.325 21.9464L18.4764 25.1565C18.7301 25.4149 18.8459 25.7872 18.786 26.1521L18.042 30.6848C18.002 30.9287 18.04 31.1794 18.1502 31.3984C18.4268 31.9482 19.0776 32.1596 19.6037 31.8706Z"
  />
</svg>

<style>
  svg {
    fill: url(#a)
  }
</style>